import React, {useState, useEffect, useRef} from 'react';
import OrgChart from '../../Common/Balkan/orgchart';
import {labels} from '../../../util/utils';
import ReactDOM from 'react-dom';
import RemoveEngagementTooltip from './removeEngagementTooltip';
import RemoveAdminsTooltip from './RemoveAdminsTooltip';
import styled, {ThemeProvider} from 'styled-components';
import theme from '@ey/styled-theme';
import {accessGroupsSelector, clientEngagementsSelector} from './Helper/dataSelector';
import LevelLegends from './LevelLegend';
import {Buffer} from 'buffer';

const Step4OrgChart = (props) => {
	const {nodes, setNodes} = props;
	let {clientEngagements} = clientEngagementsSelector(props, {showAll: true});
	let accessGroups = accessGroupsSelector();

	let divRef = useRef(null);

	let chart,
		clientXY = [0, 0];

	useEffect(() => {
		if (nodes.length > 0) {
			chart = new OrgChart(divRef.current, {
				nodes: nodes.map(x => {return {...x, escapedEntityName : _.escape(x.entityName)}}),
				template: 'ula',
				align: OrgChart.ORIENTATION,
				nodeMouseClick: OrgChart.action.none,
				enableDragDrop: false,
				enableSearch: false,
				nodeBinding: {
					field_0: 'escapedEntityName',
					field_1: 'adminsHeaderLabel',
					field_2: 'firstAdmin',
					field_3: 'adminsMoreCountLabel',
					field_4: 'domainsHeaderLabel',
					field_5: 'firstDomain',
					field_6: 'domainsMoreCountLabel',
					field_7: 'engagementLabel'
				},
				mouseScrool: OrgChart.action.scroll,
				toolbar: {
					fullScreen: false,
					zoom: true,
					fit: false,
					expandAll: false
				},
			});

			OrgChart.templates.ula.field_0 =
				'<text data-width="230" data-text-overflow="ellipsis" style="font-size: 1rem; font-weight:bold;" x="10" y="25" text-anchor="left" class="field_0">{val}</text>';
			OrgChart.templates.ula.field_1 =
				'<text data-width="150" data-text-overflow="ellipsis" style="font-size: 0.8571rem;" x="10" y="50" text-anchor="left" class="field_1">{val}</text>';
			OrgChart.templates.ula.field_2 =
				'<text data-width="100" data-text-overflow="ellipsis" style="font-size: 0.8571rem; font-weight:bold;" x="60" y="50" text-anchor="left" class="field_2">{val}</text>';
			OrgChart.templates.ula.field_3 =
				'<text width="50" text-overflow="ellipsis" style="font-size: 1.2rem;font-weight: 600; cursor: pointer;" x="180" y="50" text-anchor="right" class="svg-btn-admins field_3">{val}</text>';
			OrgChart.templates.ula.field_4 =
				'<text data-width="150" data-text-overflow="ellipsis" style="font-size: 0.8571rem;" x="10" y="65" text-anchor="left" class="field_4">{val}</text>';
			OrgChart.templates.ula.field_5 =
				'<text data-width="93" data-text-overflow="ellipsis" style="font-size: 0.8571rem; font-weight:bold;" x="67" y="65" text-anchor="left" class="field_5">{val}</text>';
			OrgChart.templates.ula.field_6 =
				'<text width="50" text-overflow="ellipsis" style="font-size: 1.2rem;font-weight: 600;cursor: pointer;" x="180" y="65" text-anchor="left" class="svg-btn-domains field_6">{val}</text>';
				OrgChart.templates.ula.field_7 = `<svg class="eng-icon svg-btn-engagement" version="1.1" id="engagementIcon" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="10" y="80"
				width="50px" height="50px" viewBox="0 0 92 92" enable-background="new 0 0 92 92" xml:space="preserve">
				<path d="M20 13H4c-.55 0-1 .45-1 1v6c0 .55.45 1 1 1h16c.55 0 1-.45 1-1v-6c0-.55-.45-1-1-1zM7 19c-1.1 0-2-.9-2-2s.9-2 2-2 2 .9 2 2-.9 2-2 2zM20 3H4c-.55 0-1 .45-1 1v6c0 .55.45 1 1 1h16c.55 0 1-.45 1-1V4c0-.55-.45-1-1-1zM7 9c-1.1 0-2-.9-2-2s.9-2 2-2 2 .9 2 2-.9 2-2 2z"></path>
				</svg><g class="svg-btn-engagement"><text width="230" text-overflow="ellipsis" style="font-size: 0.8571rem;cursor: pointer;" x="25" y="90" text-anchor="left" class="field_7">{val}</text></g> `;

			chart.on('field', function (sender, args) {
				if ( args.name == "engagementLabel") {
					var name = args.data[args.name];
					var arrayLabel = name.split(":");
					var value =  arrayLabel[1].trim();
					var engagementCountCss = value > 0 ? 'eng_count' :  '';
					args.value = `<tspan>${arrayLabel[0] + ": "}</tspan><tspan class='${engagementCountCss} textbold'>${value}</tspan><title>${value}</title>`;
				}
			});
			
			chart.on('init', function(sender) {
				var plusBtn = document.querySelector('[data-tlbr="plus"]');
				var minusBtn = document.querySelector('[data-tlbr="minus"]');

				plusBtn?.setAttribute('title', labels.zoomIn);
				minusBtn?.setAttribute('title', labels.zoomOut);
			});

			chart.on('redraw', function() {
				var adminsBtns = document.querySelectorAll('.svg-btn-admins');
				var domainsBtns = document.querySelectorAll('.svg-btn-domains');
				for (var i = 0; i < adminsBtns.length; i++) {
					adminsBtns[i].addEventListener('click', function(e) {
						e.preventDefault();
						e.stopPropagation();
						var tooltip = document.getElementById('tooltip-step4');
						var unSortedadmins = chart.get(this.parentNode.getAttribute('data-n-id')).admins;
						var sortedAdmins = _.sortBy(unSortedadmins, 'firstName');
						var elements = sortedAdmins.map((v) => {
							return `${v.firstName} ${v.lastName}`;
						});
						ReactDOM.render(
							<ThemeProvider theme={theme}>
								<RemoveAdminsTooltip
									nodeId={this.parentNode.getAttribute('data-n-id')}
									elements={elements}
									nodes={nodes}
									setNodes={setNodes}
								/>
							</ThemeProvider>,
							document.querySelector('#custom-tooltip-step4')
						);
						tooltip.classList.add('visible');

						var btns = document.querySelectorAll('#closeTooltip-admins');
						for (var i = 0; i < btns.length; i++) {
							btns[i].addEventListener('click', function(e) {
								var tooltip = document.getElementById('tooltip-step4');
								tooltip.classList.remove('visible');
							});
						}
						return false;
					});
				}

				for (var i = 0; i < domainsBtns.length; i++) {
					domainsBtns[i].addEventListener('click', function(e) {
						e.preventDefault();
						e.stopPropagation();
						var tooltip = document.getElementById('tooltip-step4');

						ReactDOM.render(
							<ThemeProvider theme={theme}>
								<RemoveAdminsTooltip
									nodeId={this.parentNode.getAttribute('data-n-id')}
									elements={chart.get(this.parentNode.getAttribute('data-n-id')).domains}
									nodes={nodes}
									setNodes={setNodes}
								/>
							</ThemeProvider>,
							document.querySelector('#custom-tooltip-step4')
						);
						tooltip.classList.add('visible');

						var btns = document.querySelectorAll('#closeTooltip-admins');
						for (var i = 0; i < btns.length; i++) {
							btns[i].addEventListener('click', function(e) {
								var tooltip = document.getElementById('tooltip-step4');
								tooltip.classList.remove('visible');
							});
						}
						return false;
					});
				}

				var engagementBtns = document.querySelectorAll('.svg-btn-engagement');
				for (var i = 0; i < engagementBtns.length; i++) {
					engagementBtns[i].addEventListener('click', function(e) {
						e.preventDefault();
						e.stopPropagation();
						var tooltip = document.getElementById('tooltip-step4');

						ReactDOM.render(
							<ThemeProvider theme={theme}>
								<RemoveEngagementTooltip
									nodeId={this.parentNode.getAttribute('data-n-id')}
									entityName={chart.get(this.parentNode.getAttribute('data-n-id')).entityName}
									engagements={chart.get(this.parentNode.getAttribute('data-n-id')).engagements}
									allEngagements={clientEngagements}
									nodes={nodes}
									setNodes={setNodes}
									disableRemove={true}
								/>
							</ThemeProvider>,
							document.querySelector('#custom-tooltip-step4')
						);
						tooltip.classList.add('visible');

						var btns = document.querySelectorAll('#closeTooltip-engagement');
						for (var i = 0; i < btns.length; i++) {
							btns[i].addEventListener('click', function(e) {
								var tooltip = document.getElementById('tooltip-step4');
								tooltip.classList.remove('visible');
							});
						}
						return false;
					});
				}
			});

			chart.load(nodes.map(x => {return {...x, escapedEntityName : _.escape(x.entityName)}}));
		}
	});

	return (
		<StyledOrgWrapper className="orgChart-container">
			<LevelLegends nodes={nodes} />
			<section id="tree" className="step4-org-tree" ref={divRef}></section>
			<section id="tooltip-step4" class="tooltip-menu">
					<section id="custom-tooltip-step4" class="step4-tooltip tooltip-content"></section>
			</section>
		</StyledOrgWrapper>
	);
};
export default Step4OrgChart;

const StyledOrgWrapper = styled.section`
	position: relative;
	.edit-tags {
		display: none;
	}
	.bg-toolbar-container {
		left: 30px;
		top: 30px;
		width: 4rem;
		height: 7.5rem;
	}

	.legends-wrap {
		top: var(--px-18);
		left: var(--px-54);
		margin-left: var(--px-32);
	}

	.step4-org-tree {
		width: 100% !important;
		height: 750px;

		border-radius: 0.8rem;
		svg {
			background: ${(props) => props.theme.color[`white`]};
			rect {
				fill: ${(props) => props.theme.color[`white`]} !important;
				cursor: default !important;
			}

			.field_0 {
				fill: ${(props) => props.theme.color[`black`]} !important;
				font-family: var(--primary-font);
				font-weight: 400 !important;
			}
			.field_1,
			.field_2,
			.field_4,
			.field_5 {
				fill: ${(props) => props.theme.color[`grey400`]} !important;
				font-family: var(--primary-font);
				font-weight: 400 !important;
			}

			.field_1,
			.field_4 {
				font-weight: 300 !important;
			}

			.eng_count,
			.field_3,
			.field_6 {
				fill: ${(props) => props.theme.color[`blue600yellow400`]} !important;
				font-family: var(--primary-font);
			}
			.field_7 {
				fill: ${(props) => props.theme.color[`grey400`]};
				font-family: var(--primary-font);
				font-weight: 300 !important;
			}

			.field_7 {
				tspan:nth-child(2) {
					font-weight: 400 !important;
				}
			}
			.eng-icon {
				fill: ${(props) => props.theme.color[`black`]};
			}
		}
	}
	.step4-tooltip {
		.eng-row {
			border-bottom: 0;
			padding-bottom: 0;
			&:last-child {
				padding-bottom: 1rem;
			}
		}
	}
	.tooltip-menu {
		opacity: 1;
		background-color: rgb(255, 254, 255);
		box-shadow: rgb(220, 220, 220) 0px 1px 2px 0px;
		display: inline-block;
		z-index: 1000;
		position: fixed;
		text-align: left;
		user-select: none;
		width: 40rem;
		top: 38.5%;
		right: 2%;
	}
	[sl='0'] line {
		stroke: ${(props) => props.theme.color[`green400`]};
	}
	[sl='1'] line {
		stroke: ${(props) => props.theme.color[`blue400`]};
	}
	[sl='2'] line {
		stroke: ${(props) => props.theme.color[`orange500`]};
	}
	[sl='3'] line {
		stroke: ${(props) => props.theme.color[`purple200`]};
	}

	.tooltip-content {
		width: 100%;
		height: 100%;
		display: inline-block;
		z-index: 9999;
		border: solid 1px ${(props) => props.theme.color[`grey300`]};
		font-size: 1.3rem;
		background-color: ${(props) => props.theme.color[`white`]};
		box-shadow: 3px 6px 6px 0px ${(props) => props.theme.color[`grey300black`]};

		.eng-row {
			border-bottom: 0;
			padding-bottom: 0;
		}
	}

	.visible .tooltip .tooltip-content {
		opacity: 1;
		-webkit-transform: translate3d(0, 50%, 0) rotate3d(0, 0, 0, 0);
		transform: translate3d(0, 50%, 0) rotate3d(0, 0, 0, 0);
		pointer-events: auto;
	}
	.visible .tooltip {
		opacity: 1;
	}
	.tooltip-menu.visible {
		display: block;
	}
	.tooltip-menu {
		display: none;
	}

	.svg-btn-engagement,
	.svg-btn-accessgroup {
		text {
			&:hover {
				font-weight: bold;
			}
		}
	}
	.textbold {
		font-weight: bold;
	}
`;
